module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    attrs: {
      "id": "toc"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Acknowldgments"
    }
  }, [_c('em', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Preface"
    }
  }, [_c('em', [_vm._v("Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Introduction"
    }
  }, [_c('em', [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Chap01"
    }
  }, [_vm._v("1: The Medieval Call for Reform")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2: The Renaissance")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3: Carried Along by Misunderstandings")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4: Conflict Among the Reformers")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5: What the Reformers Meant by "), _c('em', [_vm._v("Sola Fide")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6: What the Reformers Meant by "), _c('em', [_vm._v("Sola Scriptura")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7: How the Anabaptists Fit In")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8: Reformation in Rome")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9: Changing Direction")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10: Was the Reformation a Success?")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11: Is the Reformation a Norm?")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12: The Reformation as Triumph and Tragedy")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NameIndex",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Name Index")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SubjectIndex",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Subject Index")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Endorsements",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Praise for "), _c('em', [_vm._v("Getting the Reformation Wrong")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/MoreTitlesfromIVP",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Titles from InterVarsity Press")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78ee341a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/contents.vue
// module id = 66
// module chunks = 0